import 'i18next';
import { i18n } from '@cez-dje/providers';
import snapFormCS from './locales/cs/snapForm.json';

export const translationResources = {
  cs: {
    snapForm: snapFormCS,
  },
} as const;

export const addTranslationResources = () => {
  i18n.addResourceBundle('cs', 'snapForm', snapFormCS, true, true);
};

declare module 'i18next' {
  interface CustomTypeOptions {
    defaultNS: 'snapForm';
    resources: (typeof translationResources)['cs'];
  }
}
